import { useMutation } from "@apollo/client/react";

import { sortField } from "@smart/itops-utils-basic";
import {
  mutationDocuments,
  queryDocuments,
} from "@smart/manage-gql-operations-dom";

import { useQueryFactory } from "./base";
import { optimisticOperation } from "../cache";

export const useUpdateCustomisedContactDetails = () =>
  useMutation(mutationDocuments.updateCustomisedContactDetails, {
    update: (cache, { data }) => {
      if (!data?.updateCustomisedContactDetails) return;

      const updated = data.updateCustomisedContactDetails;
      cache.updateQuery(
        { query: queryDocuments.customisedContactDetails },
        (ex) => {
          const existing = ex?.customisedContactDetails || [];
          const without = existing.filter((item) => item.uri !== updated.uri);

          return {
            customisedContactDetails: [updated, ...without],
            __typename: "Query" as const,
          };
        },
      );
    },
  });

export const useLoadCustomisedContactDetails = useQueryFactory(
  queryDocuments.customisedContactDetails,
  {
    map: ({ customisedContactDetails }) =>
      sortField(
        customisedContactDetails.filter((item) => !item.deleted),
        { key: (item) => item.updatedAt || item.createdAt, dir: "desc" },
      ),
  },
);

export const useDeleteCustomisedContactDetails = () =>
  useMutation(mutationDocuments.deleteCustomisedContactDetails, {
    optimisticResponse: optimisticOperation("deleteCustomisedContactDetails"),
    update: (cache, { data }, { variables }) => {
      if (!data?.deleteCustomisedContactDetails || !variables) return;

      const { uri } = variables;
      cache.modify({
        id: cache.identify({ __typename: "CustomisedContactDetails", uri }),
        fields: {
          deleted: () => true,
          updatedAt: () => data.deleteCustomisedContactDetails.createdAt,
        },
      });

      cache.updateQuery(
        { query: queryDocuments.customisedContactDetails },
        (ex) => {
          if (!ex?.customisedContactDetails) return ex;

          return {
            customisedContactDetails: ex.customisedContactDetails.filter(
              (item) => item.uri !== uri,
            ),
            __typename: "Query" as const,
          };
        },
      );
    },
  });
